import { render, staticRenderFns } from "./landingLayout.vue?vue&type=template&id=1b153b08&scoped=true&"
import script from "./landingLayout.vue?vue&type=script&lang=js&"
export * from "./landingLayout.vue?vue&type=script&lang=js&"
import style0 from "./landingLayout.vue?vue&type=style&index=0&id=1b153b08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b153b08",
  null
  
)

export default component.exports